import { DEFAULT_ERROR } from '@/constants/errors';
import {
  ModelElementsState,
  SearchModelElementDataState,
} from '@/redux/modelElements/modelElements.types';
import { FetchDataState, MultiFetchDataState } from '@/types/fetchDataState';
import { ModelElement } from '@/types/models';

export const MODEL_ELEMENTS_SEARCH_INITIAL_STATE_MOCK: MultiFetchDataState<
  SearchModelElementDataState[]
> = {
  data: [],
  loading: 'idle',
  error: DEFAULT_ERROR,
};

export const MODEL_ELEMENTS_INITIAL_STATE_MOCK: ModelElementsState = {
  data: {},
  search: MODEL_ELEMENTS_SEARCH_INITIAL_STATE_MOCK,
};

export const MODEL_ELEMENTS_STATE_INITIAL_MODEL_MOCK: FetchDataState<Array<ModelElement>> = {
  data: [],
  loading: 'idle',
  error: DEFAULT_ERROR,
};
